import { UserSendEmailResponse } from 'sources/model/user-source-send-email-response';
import { BffResponseObject } from 'sources/model/response';
// bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger } from 'bernie-logger';

// mobx
import { makeObservable, action, observable, flow, computed } from 'mobx';

// data
import { User, UserV2 } from 'models';
import { UserSource } from 'sources';

import { IUserRelationship, IProgramRelationship } from '../sources/model/program-relationships';

export class UserStore extends Store {
  public enrolledPrograms: IProgramRelationship[];
  public unenrolledPrograms: IProgramRelationship[];
  public programsFetched: boolean;
  public pzPartnerId: string;
  public hasCjAccount: boolean;
  public pzAccountName: string;
  public activeProgramId: string;

  private readonly userSource: UserSource;

  public constructor(userSource: UserSource, state: SerializedData = {}, logger: Logger) {
    super(state, logger);
    this.userSource = userSource;

    makeObservable(this, {
      enrolledPrograms: observable,
      unenrolledPrograms: observable,
      hasCjAccount: observable,
      pzPartnerId: observable,
      pzAccountName: observable,
      programsFetched: observable,
      activeProgramId: observable,
      setActiveProgramId: action,
      addEnrolledProgram: action,
      addEnrolledPrograms: action,
      activeProgram: computed,
      fetchPrograms: flow,
      sendVerifyUpdateEmail: flow,
      setUnenrolledPrograms: action,
      createUser: action,
      createUserV2: action,
      sendVerificationEmail: action,
      sendForgotPasswordEmail: action,
      setPassword: action,
      verifyUser: action,
      markLastLogin: action,
    });

    this.activeProgramId = '';
    this.enrolledPrograms = [];
    this.unenrolledPrograms = [];
  }

  public hydrate(data: SerializedData): void {
    if (data.userSource) {
      // hydrating the client userSource with server side data
      Object.assign(this.userSource, data.userSource);
    }

    delete data.userSource;
    Object.assign(this, data);
  }

  // Deprecated
  public createUser(user: User) {
    return this.userSource.createUser(user);
  }

  public createUserV2(user: UserV2) {
    return this.userSource.createUserV2(user);
  }

  public sendVerificationEmail(email: string, locale: string) {
    return this.userSource.sendVerificationEmail(email, locale);
  }

  public sendForgotPasswordEmail(email: string, locale: string): Promise<UserSendEmailResponse> {
    return this.userSource.sendForgotPasswordEmail(email, locale);
  }

  public setPassword(password: string) {
    return this.userSource.setPassword(password);
  }

  public verifyUser(email: string) {
    return this.userSource.verifyUser(email);
  }

  public markLastLogin(email: string) {
    return this.userSource.markLastLogin(email);
  }

  public setActiveProgramId(id: string) {
    this.activeProgramId = id;
  }

  get activeProgram() {
    return (
      this.enrolledPrograms.find((p) => p.name === this.activeProgramId) ||
      this.unenrolledPrograms.find((p) => p.name === this.activeProgramId)
    );
  }

  public addEnrolledProgram(program: IProgramRelationship) {
    const newPrograms = [...this.enrolledPrograms, program];
    this.enrolledPrograms = newPrograms;
  }

  public addEnrolledPrograms(programs: IProgramRelationship[]) {
    const newPrograms = [...this.enrolledPrograms, ...programs];
    this.enrolledPrograms = newPrograms;
  }

  public *fetchPrograms(email: string, token: string, showHidden: boolean) {
    const newPrograms: BffResponseObject<IUserRelationship> = yield this.userSource.fetchPrograms(
      email,
      token,
      showHidden,
    );
    this.pzPartnerId = newPrograms.resBody.pzPartnerId;
    this.hasCjAccount = newPrograms.resBody.hasCjAccount;
    this.pzAccountName = newPrograms.resBody.pzAccountName;
    this.enrolledPrograms = newPrograms.resBody.enrolled;
    this.unenrolledPrograms = newPrograms.resBody.unenrolled;
    this.programsFetched = true;
  }

  public *sendVerifyUpdateEmail(email: string, locale: string, firstName: string): Generator<Promise<void>> {
    yield this.userSource.sendVerifyUpdateEmail(email, locale, firstName);
  }

  public setUnenrolledPrograms(unenrolledPrograms: IProgramRelationship[]): void {
    this.unenrolledPrograms = unenrolledPrograms;
  }
}
